package com.tovtalk.ui.scaffold

import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

/**
 * Shared constants for [ScreenScaffold] and related scaffold components.
 *
 * Centralized so Sub-project 2 (responsive layouts) can tune these without
 * hunting magic numbers.
 */
object ScaffoldDefaults {
    /**
     * Content window insets for [ScreenScaffold].
     *
     * Zero because the app uses [androidx.compose.foundation.layout.systemBarsPadding]
     * at the root (see `TovTalkApp.kt`) and iOS uses `.ignoresSafeArea(.all)`.
     * Matches the existing convention in `AppScaffold`.
     */
    val contentWindowInsets: WindowInsets = WindowInsets(0, 0, 0, 0)

    /**
     * Maximum content width on [com.tovtalk.ui.adaptive.WindowSizeClass.Expanded] windows
     * when `constrainContentWidth = true`. Prevents secondary screens (settings, profile,
     * etc.) from stretching absurdly wide on desktop.
     */
    val maxContentWidthExpanded: Dp = 720.dp
}
